<template>
  <div :class="$style.wrapper">
    <v-help ref="errorBox" button="Ok">{{errorText}}</v-help>
    <div :class="$style.title">{{site.title}}</div>
    <div :class="$style.body">
      <div>
        <svg width="219" height="350" viewBox="0 0 219 350" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="183" height="30" rx="15" fill="#DCDCE7"/>
          <rect y="45" width="119" height="30" rx="15" fill="#DCDCE7"/>
          <rect x="134" y="45" width="85" height="30" rx="15" fill="#DCDCE7"/>
          <rect y="90" width="71" height="30" rx="15" fill="#DCDCE7"/>
          <rect x="83" y="90" width="136" height="30" rx="15" fill="#DCDCE7"/>
          <rect y="135" width="119" height="30" rx="15" fill="#DCDCE7"/>
          <rect x="134" y="135" width="85" height="30" rx="15" fill="#DCDCE7"/>
          <rect x="166" y="320" width="53" height="30" rx="15" fill="#DCDCE7"/>
        </svg>
      </div>

      <portal to="outer">
        <transition name="slide-up">
          <phone v-if="authOpened" :code="authPass" />
        </transition>
      </portal>

      <transition name="bounce">
        <div :class="$style.form" v-if="!authOpened">
          <v-input disabled v-model="email" />
          <v-input disabled v-model="oldPassword" />
          <v-input :error="errorPass" placeholder="Новый пароль" v-model="newPassword" />
          <v-check :error="errorAuth" :class="$style.check" v-model="auth" lg>Двухфакторная авторизация</v-check>
          <v-btn large color="green" @click="handleClick">Сохранить</v-btn>
        </div>
        <div v-else :class="$style.auth">
          <span>Двухфакторная авторизация</span>
          <v-input :error="errorPass" placeholder="Пароль из СМС" v-model="authValue" />
          <v-btn large color="green" @click="checkAuth">Сохранить</v-btn>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import phone from './phone'

const oneUpperChar = /(?=.*?[A-ZА-Я])/
const oneLowerChar = /(?=.*?[a-zа-я])/
const oneDigit = /(?=.*?[0-9])/
const oneSpecialChar = /(?=.*?[#?!@$%^&*-_.\\()"+=;:,/|])/

const bannedWords = ['skobec', 'скобец', '1996', '1995', '2000']

const checkPass = (pass, sites) => {
  if (pass.length < 12) {
    return {
      result: false,
      text: 'Пароль должен быть длиной минимум 12 симоволов',
    }
  }
  if (bannedWords.find(item => pass.indexOf(item) > -1)) {
    return {
      result: false,
      text: 'Пароль не должен содержать в себе общедоступную информацию',
    }
  }
  if (!oneUpperChar.test(pass)) {
    return {
      result: false,
      text: 'Пароль должен содержать минимум одну заглавную букву',
    }
  }
  if (!oneLowerChar.test(pass)) {
    return {
      result: false,
      text: 'Пароль должен содержать минимум одну строчную букву',
    }
  }
  if (!oneDigit.test(pass)) {
    return {
      result: false,
      text: 'Пароль должен содержать минимум одну цифру',
    }
  }
  if (!oneSpecialChar.test(pass)) {
    return {
      result: false,
      text: 'Пароль должен содержать минимум один специальный символ',
    }
  }
  if (sites.find(item => item.password === pass)) {
    return {
      result: false,
      text: 'Пароли на разных сайтах должны различаться',
    }
  }
  return {
    result: true,
  }
}

const getRandomString = () => {
  const randomChars = '0123456789'
  let result = ''
  for (let i = 0; i < 6; i += 1) {
    result += randomChars.charAt(Math.floor(Math.random() * randomChars.length))
  }
  return result
}

export default {
  name: 'one-site',
  components: { phone },
  props: {
    site: Object,
    sites: Array,
  },
  data: () => ({
    email: 'skobec@poch***t.com',
    oldPassword: 'skobec12345678',
    newPassword: '',
    auth: false,
    errorPass: false,
    errorAuth: false,
    errorText: '',
    authOpened: false,
    authPass: '212456',
    authValue: '',
  }),
  methods: {
    handleClick() {
      this.errorPass = false
      this.errorAuth = false
      this.$refs.errorBox.close()

      setTimeout(() => {
        const { result, text } = checkPass(this.newPassword, this.sites)
        this.errorText = text
        this.errorPass = !result

        if (this.errorPass) {
          this.$refs.errorBox.open()
          return
        }

        if (!this.auth) {
          this.errorAuth = true
          this.errorText = 'Необходимо включить двухфакторную авторизацию'
          this.$refs.errorBox.open()
          return
        }

        this.openAuth()
      }, 500)
    },
    openAuth() {
      this.authPass = getRandomString()
      this.authOpened = true
    },
    checkAuth() {
      this.$refs.errorBox.close()

      setTimeout(() => {
        if (this.authValue !== this.authPass) {
          this.errorText = 'Код не совпадает!'
          this.$refs.errorBox.open()
          return
        }
        this.site.ready = true
        this.site.password = this.newPassword
        this.$emit('close')
      }, 500)
    },
  },
}
</script>
<style lang="scss" module>
.wrapper {
  background: #F0F0F5;
  border-radius: 1.5rem;
  width: 78rem;
  margin: 0 auto;
  margin-top: 1.5rem;
  height: 47.1rem;
  padding: 3.5rem;
}

.title {
  text-align: center;
  font-size: 2.1rem;
  margin-bottom: 3rem;
}

.body {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 1.6rem;

  & > div:nth-child(1) {
    width: 21.9rem;

    svg {
      width: 100%;
      height: auto;
    }
  }

  & > div:nth-child(2) {
    width: 29.5rem;
  }
}

.check {
  margin-top: 1rem;
}

.form, .auth {
  margin-right: 8rem;

  button {
    display: block;
    margin: 0 auto;
    margin-top: 3.2rem;
  }
}

.auth {
  margin-top: 10rem;

  & > span {
    margin-bottom: 1rem;
    display: block;
  }
}
</style>
